export default __webpack_public_path__ + "static/media/working-new-3.4ad9eaab.png";